import './BlockImage.css';

function BlockImage(props) {
 
  return (
    <div id="BlockImage">
      <img className={`BlockContent-img ${props.shadow === false ? 'no-shadow' : ''}`}  src={props.src} alt=''/>
      <p className='BlockContent-img-title'>{props.title}</p>
      
    </div>

  );
}

export default BlockImage;
